export default {
  back: 'Zurück zum Menü',
  menu: 'Menü',
};
